import sqlFormatter from "@sqltools/formatter";

const KEYWORDS = [
  "SELECT",
  "FROM",
  "WHERE",
  "GROUP BY",
  "ORDER BY",
  "LIMIT",
  "INSERT",
  "UPDATE",
  "VALUES",
];

const HELPING_KEYWORDS = [
  "AND",
  "AS",
  "BETWEEN",
  "LEFT JOIN",
  "INNER JOIN",
  "OUTER JOIN",
  "RIGHT JOIN",
  "JOIN",
  "SET",
];

const OPERATION_KEYWORD = ["SUM", "AVG"];

export const convertQueryToHtmlQuery = (sqlQuery = ""): string => {
  //this is used to replace the \n\n so A new line is added
  const DUAL_NEW_LINE_PLACEHOLDER = "____LINE_BREAK___2____";
  const NEW_LINE_PLACEHOLDER = "____LINE_BREAK___";
  try {
    return sqlFormatter
      .format(
        sqlQuery
          ?.replaceAll(/\n\n/g, DUAL_NEW_LINE_PLACEHOLDER)
          ?.replaceAll(/\n/g, NEW_LINE_PLACEHOLDER)
      )
      .replaceAll(DUAL_NEW_LINE_PLACEHOLDER, "\n\n")
      .replaceAll(NEW_LINE_PLACEHOLDER, "\n")
      .split("\n")
      .map((line: string) => {
        let coloredLine = line;

        //boundary check added to avoid matching the word in the middle of other words
        KEYWORDS?.map((item) => {
          const keywordRegex = new RegExp(`\\b${item}\\b`, "gi");
          if (coloredLine?.match(keywordRegex)) {
            coloredLine = coloredLine?.replace(
              keywordRegex,
              (matchedValue: string) => {
                return `<span class="query-reserved-word">${matchedValue}</span>`;
              }
            );
          }
          return item;
        });

        HELPING_KEYWORDS?.map((helpingKeyword) => {
          const helpingWordRegex = new RegExp(`\\b${helpingKeyword}\\b`, "gi");

          if (coloredLine?.match(helpingWordRegex)) {
            coloredLine = coloredLine?.replace(
              helpingWordRegex,
              (matchedValue: string) => {
                return `<span class="helping-word">${matchedValue}</span>`;
              }
            );
          }
          return helpingKeyword;
        });

        OPERATION_KEYWORD?.map((operationalKeyword) => {
          const operationalWordRegex = new RegExp(
            `\\b${operationalKeyword}\\b`,
            "gi"
          );
          if (coloredLine?.match(operationalWordRegex)) {
            coloredLine = coloredLine?.replace(
              `${operationalWordRegex}`,
              (matchedValue: string) => {
                return `<span class="operation-word">${matchedValue}</span>(`;
              }
            );
          }
          return operationalKeyword;
        });

        const valueReg = /'(.*?)'/g;
        coloredLine = coloredLine?.replaceAll(
          valueReg,
          (matchedValue: string) => {
            return `<span class="value-statement">${matchedValue}</span>`;
          }
        );

        return `<div class="query-line">${coloredLine || ""}</div>`;
      })
      .join("");
  } catch {
    return "";
  }
};
